import React, { PropsWithChildren } from 'react';
import './table.scss';
export { default } from './Table';

export const Hidden: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="juniper-datatable-hover-reveal">{children}</div>
);
